/**
 * LES GESTES DE LA FICHE OUVERTE, la logique sans ecran (testee par
 * `gestes.test.mjs`). Decision du fondateur le 28/10/2026 a 21 h 30 : la rangee
 * de la fiche ne garde que « Clôturer » (ou « Rouvrir ») et « Dossier de
 * l'animal », cote a cote, a gauche, jamais au menu « ... ». « Modifier
 * l'animal » et « Fiche » sont retires : l'icone « Fiche » du selecteur de vues,
 * a droite, suffit.
 *
 * Le dossier les declare en `rangee`, dans cet ordre. Le plafond de la rangee
 * est celui du socle (`repartirLesActions`), pas celui de l'app.
 *
 * « Dossier de l'animal » est absent sans destination ou sans animal, grise
 * pendant la lecture de l'animal.
 */

import type { ActionDeVueDeFiche } from '@taki/app-runtime';

/** L'etat de la lecture de l'animal : lu, en cours de lecture, ou la consultation n'en a pas. */
export type EtatDeLAnimal = 'lu' | 'en-lecture' | 'aucun';

export interface EntreesDesGestes {
  cloturee: boolean;
  /** L'etape de la consultation (`stage`) : on ne rouvre que depuis « aFacturer ». */
  etape: string;
  /** Le dossier lit encore l'animal, ses soins ou le catalogue. */
  chargement: boolean;
  /** La raison qui bloque la cloture (la premiere), ou `null`. */
  bloquant: string | null;
  etatDeLAnimal: EtatDeLAnimal;
  cloturer(): void;
  rouvrir(): void;
  /** Le dossier de l'animal dans l'app qui le montre ; `null` : aucune destination, le geste n'est pas propose. */
  ouvrirDossierDeLAnimal: (() => void) | null;
}

/** La rangee de la fiche, dans l'ordre : le geste principal, puis le dossier de l'animal. */
export function gestesDeLaFiche(entrees: EntreesDesGestes): ActionDeVueDeFiche[] {
  const rangee: ActionDeVueDeFiche[] = [];
  if (!entrees.cloturee) {
    rangee.push({
      id: 'cloturer',
      libelle: 'Clôturer',
      variante: 'primary',
      ...(entrees.chargement ? { desactivee: 'Le dossier se charge.' } : entrees.bloquant !== null ? { desactivee: entrees.bloquant } : {}),
      onClick: entrees.cloturer,
    });
  } else if (entrees.etape === 'aFacturer') {
    rangee.push({ id: 'rouvrir', libelle: 'Rouvrir', variante: 'secondary', onClick: entrees.rouvrir });
  }
  if (entrees.ouvrirDossierDeLAnimal !== null && entrees.etatDeLAnimal !== 'aucun') {
    rangee.push({
      id: 'dossier-animal',
      libelle: "Dossier de l'animal",
      ...(entrees.etatDeLAnimal === 'en-lecture' ? { desactivee: "L'animal se charge." } : {}),
      onClick: entrees.ouvrirDossierDeLAnimal,
    });
  }
  return rangee;
}
